module.exports = __webpack_public_path__ + "img/main-02-03.f45fd859.png";